export const arTranslation = {
  common: {
    loading: 'جاري التحميل...',
    error: 'حدث خطأ',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    search: 'بحث',
    noData: 'لا توجد بيانات',
    confirm: 'تأكيد',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    retry: 'إعادة المحاولة',
    offline: 'أنت غير متصل بالإنترنت',
    appName: 'Tamam Driver',
  },
  auth: {
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    register: 'إنشاء حساب',
    phoneNumber: 'رقم الهاتف',
    password: 'كلمة المرور',
    fullName: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    confirmPassword: 'تأكيد كلمة المرور',
    forgotPassword: 'نسيت كلمة المرور؟',
    rememberMe: 'تذكرني',
    noAccount: 'ليس لديك حساب؟',
    hasAccount: 'لديك حساب بالفعل؟',
    createAccount: 'إنشاء حساب جديد',
    loginTitle: 'سجل دخولك لبدء التوصيل',
    registerTitle: 'انضم إلى أسطول Tamam',
    otpTitle: 'تأكيد رقم الهاتف',
    otpSubtitle: 'أدخل رمز التحقق المرسل إلى',
    resendCode: 'إعادة الإرسال',
    seconds: 'ثانية',
    verify: 'تأكيد',
    step1: 'الخطوة 1: المعلومات الشخصية',
    step2: 'الخطوة 2: معلومات المركبة',
    vehicleType: 'نوع المركبة',
    plateNumber: 'رقم اللوحة',
    acceptTerms: 'أوافق على الشروط والأحكام',
    terms: 'الشروط والأحكام',
    invalidPhone: 'رقم الهاتف غير صحيح',
    invalidPassword: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
    invalidName: 'الاسم يجب أن يكون حرفين على الأقل',
    passwordMismatch: 'كلمة المرور غير متطابقة',
    acceptTermsRequired: 'يجب الموافقة على الشروط',
    loginSuccess: 'تم تسجيل الدخول بنجاح',
    registerSuccess: 'تم إنشاء حسابك بنجاح',
    otpVerified: 'تم التحقق من رقم الهاتف بنجاح',
  },
  driver: {
    online: 'متصل',
    offline: 'غير متصل',
    goOnline: 'بدء العمل',
    goOffline: 'إنهاء العمل',
    dashboard: 'لوحة التحكم',
    earnings: 'الأرباح',
    todayEarnings: 'أرباح اليوم',
    todayDeliveries: 'توصيلات اليوم',
    totalEarnings: 'إجمالي الأرباح',
    totalDeliveries: 'إجمالي التوصيلات',
    rating: 'التقييم',
    availableOrders: 'الطلبات المتاحة',
    noOrders: 'لا توجد طلبات متاحة',
    orderHistory: 'سجل الطلبات',
    acceptOrder: 'قبول الطلب',
    rejectOrder: 'رفض الطلب',
    pickedUp: 'تم الاستلام',
    outForDelivery: 'جاري التوصيل',
    delivered: 'تم التوصيل',
    returned: 'مرتجع',
    cancelled: 'ملغي',
    orderDetails: 'تفاصيل الطلب',
    store: 'المتجر',
    customer: 'العميل',
    address: 'العنوان',
    deliveryFee: 'رسوم التوصيل',
    totalAmount: 'المبلغ الإجمالي',
    items: 'المنتجات',
    distance: 'المسافة',
    estimatedTime: 'الوقت المتوقع',
  },
  documents: {
    title: 'المستندات',
    upload: 'رفع مستند',
    type: 'نوع المستند',
    nationalId: 'بطاقة الهوية',
    drivingLicense: 'رخصة القيادة',
    vehicleRegistration: 'تسجيل المركبة',
    insurance: 'التأمين',
    profilePhoto: 'صورة شخصية',
    expiryDate: 'تاريخ الانتهاء',
    verified: 'موثق',
    pending: 'قيد المراجعة',
    rejected: 'مرفوض',
  },
  shifts: {
    title: 'الورديات',
    addShift: 'إضافة وردية',
    day: 'اليوم',
    startTime: 'بداية الوردية',
    endTime: 'نهاية الوردية',
    active: 'نشط',
    inactive: 'غير نشط',
    monday: 'الإثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
    sunday: 'الأحد',
  },
  chat: {
    title: 'المحادثات',
    noConversations: 'لا توجد محادثات',
    typeMessage: 'اكتب رسالتك...',
    send: 'إرسال',
    support: 'الدعم الفني',
  },
  notifications: {
    title: 'الإشعارات',
    noNotifications: 'لا توجد إشعارات',
    markAllRead: 'تحديد الكل كمقروء',
    newOrder: 'طلب جديد',
    orderUpdate: 'تحديث الطلب',
  },
  api: {
    networkError: 'خطأ في الاتصال بالشبكة',
    serverError: 'خطأ في الخادم',
    unauthorized: 'انتهت الجلسة. الرجاء تسجيل الدخول مجدداً',
    notFound: 'غير موجود',
    validationError: 'خطأ في البيانات المدخلة',
    timeout: 'انتهت مهلة الاتصال',
  },
  currency: {
    egp: 'ج.م',
  },
  direction: 'rtl',
};

export default arTranslation;